const features = {
    number: ['01', '02', '03'],
    shape: ['crane', 'bird', 'squirrel'],
    color: ['blue', 'red', 'green'],
    shading: ['full', 'empty', 'striped'],


};

export default features;




// WEBPACK FOOTER //
// ./src/core/cardFeatures.js